import { useCreateFlowSession } from "@/api/flow_sessions";
import { emitCanvasOpenFloatingSession } from "@/pages/canvas/context/CanvasFloatingChatContext";
import { FLOW_SESSION_MODES } from "@cohesive/api-client";
import { useCallback } from "react";

export function useCanvasRailNewChat(canvasId: string, canEdit: boolean) {
  const createFlowSession = useCreateFlowSession();

  const handleNewChat = useCallback(async () => {
    if (!canEdit || !canvasId || createFlowSession.isPending) return;
    const newSession = await createFlowSession.mutateAsync({
      mode: FLOW_SESSION_MODES.CANVAS_CHAT,
      class: "canvas",
      canvas_id: canvasId,
    });
    emitCanvasOpenFloatingSession({
      canvasId,
      flowSessionId: newSession.id,
    });
  }, [canEdit, canvasId, createFlowSession]);

  return {
    handleNewChat,
    isCreatingChat: createFlowSession.isPending,
  };
}
